import { http } from "../../../config/HttpMethod";
import { JETLIFT_ENDPOINTS } from "../../../store/jetlift/endpoints";
import { GasCalculationData } from "../../../store/model/calculations/calculation";

export const getGasDataOnDesignChange = async (payload: any) => {
    try {
        const response = await http.post<GasCalculationData>(`${JETLIFT_ENDPOINTS?.GET_GAS_INTAKE_DATA}`, payload);
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};